// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ExportingConfig.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

import React, { Component } from 'react';
import GridLayout from 'share/components/controls/Izenda.GridLayout';
import connect from 'share/enhancers/Izenda.Connect';
import ExportingConfigAction from './Izenda.ExportingConfigAction';
import { LABEL, LABEL_COL, CONTROL_COL, ORIENTATION_OPTIONS, MARGIN_OPTIONS } from 'logic/data/Izenda.ExportConstants';
import Label from 'share/components/controls/Izenda.Label';
import DropDown from 'share/components/controls/Izenda.DropDown';
import Input from 'share/components/controls/Izenda.Input';
import OverflowText from 'share/components/controls/Izenda.OverflowText';

const { ORIENTATION, MARGIN, CENTER_ON_PAGE, HORIZONTALLY, VERTICALLY, PAGE_BREAK } = LABEL;

@connect(ExportingConfigAction)
export default class ExportingConfig extends Component {
  render() {
    const {
      model,
      changeOrientation,
      changeMargins,
      changeHorizontally,
      changeVertically,
      changePageBreak
    } = this.props;

    const { orientation, margins, centerOnPage: { horizontally, vertically }, pageBreakAfterReportPart } = model;

    return (
      <section className="u_fullHeight u-posRelative u-bgWhite u_overflowHidden">
        <div className="izenda-ExportingConfig">
          <GridLayout className="form-horizontal u_paddingAll">
            <GridLayout.Row>
              <GridLayout.Col cols={LABEL_COL}>
                <Label className="control-label u_textNormal">{ORIENTATION}</Label>
              </GridLayout.Col>
              <GridLayout.Col cols={CONTROL_COL}>
                <DropDown
                  options={ORIENTATION_OPTIONS}
                  value={orientation}
                  valueField="value"
                  labelField="label"
                  onChange={changeOrientation}
                />
              </GridLayout.Col>
            </GridLayout.Row>
            <GridLayout.Row>
              <GridLayout.Col cols={LABEL_COL}>
                <Label className="control-label u_textNormal">{MARGIN}</Label>
              </GridLayout.Col>
              <GridLayout.Col cols={CONTROL_COL}>
                <DropDown
                  options={MARGIN_OPTIONS}
                  value={margins}
                  valueField="value"
                  labelField="label"
                  onChange={changeMargins}
                />
              </GridLayout.Col>
            </GridLayout.Row>
            <hr/>
            <GridLayout.Row>
              <GridLayout.Col cols={LABEL_COL}>
                <Label className="control-label u_textNormal">{CENTER_ON_PAGE}</Label>
              </GridLayout.Col>
              <GridLayout.Col cols={CONTROL_COL}>
                <div>
                  <Input checked={horizontally} type="checkbox" onChange={changeHorizontally}/> {HORIZONTALLY}
                </div>
                <div>
                  <Input checked={vertically} type="checkbox" onChange={changeVertically}/> {VERTICALLY}
                </div>
              </GridLayout.Col>
            </GridLayout.Row>
            <hr/>
            <GridLayout.Row>
              <GridLayout.Col cols={LABEL_COL}>
                <Label className="control-label u_textNormal">{PAGE_BREAK}</Label>
              </GridLayout.Col>
              <GridLayout.Col cols={CONTROL_COL}>
                <Input
                  checked={pageBreakAfterReportPart}
                  type="checkbox"
                  onChange={changePageBreak}/>
              </GridLayout.Col>
            </GridLayout.Row>
          </GridLayout>
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Exporting/Izenda.ExportingConfig.js